<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              골프클럽 기본 정보
            </div>
          </section>
          <section class="section0201">
            <div class="object01"></div>
            <div class="object02">
              골프클럽명
            </div>
            <div class="object03">
              {{ clubInfo.club_name }}
            </div>
            <div class="object04"></div>
            <!-- 이미지(Style) : 경로 -->
            <div
              class="object05"
              :style="{ 'background-image': 'url(' + clubInfo.club_logo + ')' }"
            ></div>
            <div class="object06"></div>
          </section>
          <section class="section0202">
            <div class="object01"></div>
            <div class="object10">
              주소
            </div>
            <div class="object11">
              {{ clubInfo.club_address }}
            </div>
            <div class="object12"></div>
          </section>
          <!-- 휴장홀 노출시(Class) : closedHoleActive -->
          <section
            class="section0203"
            :class="{ closedHoleActive: clubInfo.holiday_holes }"
          >
            <div class="objectBox object01">
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object13">
                    연락처
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object14">
                    {{ clubInfo.club_telno }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object16">
                    대표자명
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object17">
                    {{ clubInfo.club_represent_name }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object19">
                    운영상태
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object20">
                    {{ getManageStatusName(clubInfo.manage_status) }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object22">
                    APL 지원 상태
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object23">
                    {{ getAplStatusName(clubInfo.apl_status) }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object25">
                    골프클럽 상태
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object26">
                    {{ getActiveStatusName(clubInfo.active_status) }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object28">
                    지역
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object29">
                    {{
                      getRegion(
                        setRegionCode(clubInfo.ccode, clubInfo.region_code)
                      )
                    }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object31">
                    핀 사이즈(mm)
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object32">
                    {{ confirmPinSize(clubInfo.pin_size) }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object34">
                    휴장일
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object35">
                    {{
                      makeOffDayTxt(
                        this.clubInfo.holiday_start,
                        this.clubInfo.holiday_end,
                        this.clubInfo.holiday_week_ju,
                        this.clubInfo.holiday_week
                      )
                    }}
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object37">
                    휴장여부
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object38">
                    {{ isTodayOff(clubInfo) ? 'O' : 'X' }}
                  </div>
                </div>
              </div>
              <div class="objectRow closedHole">
                <div class="objectTitle">
                  <div class="closedHoleTitle">
                    휴장홀
                  </div>
                </div>
                <div class="objectContent">
                  <div class="closedHoleContent">
                    <ul class="list">
                      <li v-for="(holes, course) in holidayHoles" :key="course">
                        {{ course }} - {{ holes.join('홀, ') }}홀
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object40">
                    비고
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object41">
                    {{ clubInfo.pin_change }}
                  </div>
                </div>
              </div>
              <div class="objectRow last">
                <div class="objectTitle">
                  <div class="object43">
                    특이사항
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object44">
                    {{ clubInfo.uniqueness }}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section03">
            <div
              class="object01"
              v-if="userInfo.userRole !== 'ClubManager'"
              @click="moveMenu('/SE001')"
            >
              목록
            </div>
            <div class="object02">
              최근 업데이트
              {{
                clubInfo.updt_dt === null ? clubInfo.isrt_dt : clubInfo.updt_dt
              }}
              ({{
                clubInfo.updt_name === null
                  ? clubInfo.isrt_name
                  : clubInfo.updt_name
              }}
              ID
              {{
                clubInfo.updt_id === null ? clubInfo.isrt_id : clubInfo.updt_id
              }})
            </div>
            <div
              class="object03"
              @click="moveMenu('/SE004?ccode=' + currentClubCode)"
            >
              수정하기
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import { commonService, settingService, userService } from '../../router'

export default {
  name: 'SE002',
  data () {
    return {
      clubInfo: {
        club_name: '',
        club_logo: '',
        club_address: '',
        club_telno: '',
        club_represent_name: '',
        active_status: '',
        manage_status: '',
        apl_status: '',
        isrt_id: '',
        isrt_name: '',
        isrt_dt: '',
        updt_id: '',
        updt_name: '',
        updt_dt: '',
        holidays: '',
        holiday_start: '',
        holiday_end: '',
        holiday_week_ju: '',
        holiday_week: '',
        holiday_holes: ''
      },
      selectActiveStatus: 'inactive',
      activeStatusList: [
        { name: '활성화', code: 'active' },
        { name: '비활성화', code: 'inactive' }
      ],
      selectManageStatus: 'inactive',
      manageStatusList: [
        { name: '운영중', code: 'active' },
        { name: '운영예정', code: 'inactive' }
      ],
      selectAplStatus: 'ready',
      aplStatusList: [
        { name: '서비스중', code: 'service' },
        { name: '점검중', code: 'check' },
        { name: '준비중', code: 'ready' }
      ],
      clubRegion: [
        { name: '경기/인천', code: 1 },
        { name: '충청북도', code: 10 },
        { name: '충청남도', code: 11 },
        { name: '전라도', code: 20 },
        { name: '경상북도', code: 30 },
        { name: '경상남도', code: 31 },
        { name: '강원도', code: 40 },
        { name: '제주도', code: 50 }
      ],
      pinSize: '27',
      selectPinSize: '2',
      pinSizeArr: [
        { size: '13', code: '0' },
        { size: '20', code: '1' },
        { size: '27', code: '2' }
      ],
      courseList: []
    }
  },
  created: function () {
    this.currentClubCode = this.$route.query.ccode
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (
        this.userInfo.userRole === 'ClubManager' &&
        this.userInfo.ccode !== this.$route.query.ccode
      ) {
        this.moveMenu('/')
      } else {
        this.setData()
      }
    })
    commonService
      .getCourseListByCcode(this.currentClubCode)
      .then(response => {
        this.courseList = response.data.courseList.sort((a, b) =>
          a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0
        )
      })
      .catch(error => {
        console.log('getCourseListByCcode.err.===>', error)
      })
  },
  mounted: function () {},
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      settingService
        .getClubInfoDetail(this.currentClubCode)
        .then(response => {
          this.clubInfo = response.data.clubInfo
        })
        .catch(error => {
          console.log('getClubInfoList.err.===>', error)
        })
    },
    getRegion: function (regionCode) {
      if (!regionCode) return ''
      return this.clubRegion.find(it => it.code === regionCode).name
    },
    getManageStatusName (status) {
      if (!status) return ''
      const target = this.manageStatusList.find(it => it.code === status)
      return target ? target.name : ''
    },
    getAplStatusName (status) {
      if (!status) return ''
      const target = this.aplStatusList.find(it => it.code === status)
      return target ? target.name : ''
    },
    getActiveStatusName (status) {
      if (!status) return ''
      const target = this.activeStatusList.find(it => it.code === status)
      return target ? target.name : ''
    },
    getPinSize (pinSize) {
      if (!pinSize) return ''
      const target = this.pinSizeArr.find(it => it.code === pinSize)
      return target ? target.size : ''
    },
    getCourseData: function (hlidx) {
      return this.courseList.find(
        it => it.startIdx <= hlidx && it.endIdx > hlidx
      )
    }
  },
  computed: {
    holidayHoles () {
      if (!this.clubInfo.holiday_holes) return
      return this.clubInfo.holiday_holes.split(',').reduce((acc, curr) => {
        const course = this.getCourseData(curr - 1)
        if (!course) return
        const courseName = course.name
        if (acc[courseName]) {
          acc[courseName].push(curr - course.startIdx)
        } else {
          acc[courseName] = [curr - course.startIdx]
        }
        return acc
      }, {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/setting/SE002.vue